import { apiGetFile } from "@/services/genesisApi/httpsMethods";
import type { ApiResponse } from "@/services/genesisApi/httpsMethods";

type ShowError = (response: ApiResponse) => void;

async function downloadBlobFile(
  endpoint: string,
  fileNamePrefix: string,
  extension: string,
  failureMessage: string,
  showErrorFromResponse: ShowError,
) {
  try {
    const response = await apiGetFile(endpoint);
    if (response.success && response.data) {
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      const datetime = new Date().toISOString().replace(/[:.]/g, "-");
      a.href = url;
      a.download = `${fileNamePrefix}_${datetime}.${extension}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } else {
      showErrorFromResponse({
        success: false,
        status: 500,
        message: response.message || failureMessage,
      });
    }
  } catch (error) {
    console.error(`Error generating ${fileNamePrefix}:`, error);
    showErrorFromResponse({
      success: false,
      status: 500,
      message: `${failureMessage}. Please try again.`,
    });
  }
}

export async function downloadDealVolumeReport(
  showErrorFromResponse: ShowError,
) {
  return downloadBlobFile(
    "generate-deal-volume-report",
    "Deal_Volume_Report",
    "pdf",
    "Failed to generate deal volume report",
    showErrorFromResponse,
  );
}

export async function downloadPipelineExcelReport(
  showErrorFromResponse: ShowError,
) {
  return downloadBlobFile(
    "generate-pipeline-excel-report",
    "Pipeline_Excel_Report",
    "xlsx",
    "Failed to generate pipeline excel report",
    showErrorFromResponse,
  );
}
